import Analytics from '@/utils/analytics';
import { openWebBrowserURL } from '@/utils/navigation';
import { useCallback } from 'react';

export const useGetOpenCreditMemoPDF = (
  creditMemoURL: string | null | undefined,
  creditMemoUUID: string | null | undefined,
) => {
  return useCallback(async () => {
    if (!creditMemoURL || !creditMemoUUID) {
      return;
    }

    Analytics.track('credit_memo.view_pdf', {
      creditMemoUUID: creditMemoUUID,
    });
    // Set source to prevent the app banner from rendering
    await openWebBrowserURL(`${creditMemoURL}?source=app`);
  }, [creditMemoURL, creditMemoUUID]);
};
